/* 右カラム 登録ページ遷移バナー　スクロール固定 */
$(window).on('load',function(){
  if(!$(".m3p_jobnavi-sidecolumn--cinsultant").size()) { return 0; }
  if( $('.atlas-main').outerHeight() <= $('.atlas-rhs').outerHeight() ) { return 0; }
  const topbar = $(".m3p_jobnavi-sidecolumn--cinsultant").offset().top;
  const bottombar = $(".atlas-main").outerHeight(true) - $(".m3p_jobnavi-sidecolumn--cinsultant").outerHeight(true);

  $(window).scroll(function () {
    if ($(window).scrollTop() > topbar && $(window).scrollTop() < bottombar) { // 画面が元の位置より下かつ、検索ボックスより上なら、画面右下に固定する
      $('.m3p_jobnavi-sidecolumn--cinsultant').addClass('fixed');
      $('.m3p_jobnavi-sidecolumn--cinsultant').css('top', 0);
    } else if($(window).scrollTop() > bottombar) { // 画面が検索ボックスより下なら、検索ボックスより上の位置に固定する
      $('.m3p_jobnavi-sidecolumn--cinsultant').removeClass('fixed');
      $('.m3p_jobnavi-sidecolumn--cinsultant').addClass('stick');
      $('.m3p_jobnavi-sidecolumn--cinsultant').css('top', bottombar + 'px');
    } else {
      // それ以外(画面が元の位置より上)の時、スクロール固定を解除する
      $('.m3p_jobnavi-sidecolumn--cinsultant').removeClass('stick');
      $('.m3p_jobnavi-sidecolumn--cinsultant').removeClass('fixed');
    }
  });
});